module.exports = __webpack_public_path__ + "img/corriente_b_blue.71a75dfd.svg";